import type React from 'react'
import type { JSX } from 'react'
import type { ButtonGroupMargin } from './interfaces'

import { Wrapper } from './ButtonGroup.styled'
import {
  ColumnGap,
  Direction,
  Fluid,
  JustifyContent,
  Padding,
} from './interfaces'

export interface IButtonGroupProps {
  children: React.ReactNode
  width?: number
  columnGap?: ColumnGap
  padding?: Padding
  wrap?: boolean
  direction?: Direction
  justifyContent?: JustifyContent
  fluid?: Fluid
  maxHeight?: number
  margins?: ButtonGroupMargin
  className?: string
}

export const ButtonGroup = ({
  children,
  width,
  columnGap = ColumnGap.INDENT_20,
  padding = Padding.INDENT_0,
  wrap,
  direction = Direction.Row,
  justifyContent = JustifyContent.FlexStart,
  fluid = Fluid.None,
  maxHeight,
  margins,
  className,
}: IButtonGroupProps): JSX.Element => (
  <Wrapper
    className={className}
    width={width}
    direction={direction}
    justifyContent={justifyContent}
    columnGap={columnGap}
    padding={padding}
    buttonWrap={wrap}
    fluid={fluid}
    maxHeight={maxHeight}
    margins={margins}
  >
    {children}
  </Wrapper>
)
